import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";

export class RewardStopOutputBlock extends RewardGraphNode {

    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this._isUnique = true;
        this.registerInput("stop", RewardGraphConnectionPointTypes.Boolean);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardStopOutputBlock";
    }
    /**
     * Gets the reward input component
     */
    public get stop(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    protected override _buildBlock(state: RewardGraphBuildState) {
        state.stopData = this.stop.getConnectedValue(state);
    }
}

RegisterClass("MELS.RewardStopOutputBlock", RewardStopOutputBlock);
